import React from 'react';

import styled from '@emotion/styled';

import Page from '../../components/Page/Page';
import TrackPackageForm from './TrackPackageForm';

const Home = () => {
  return (
    <Page title="Darum | track package home">
      <Container>
        <TextAndForm>
          <TextArea>
            <Header>
              You deserved a delivery service that is
              <span> swift and secured</span>
            </Header>
            <Description>
              We prioritize the safe and timely arrival of your packages. With
              advanced tracking technology and a commitment to excellence, we
              ensure your shipments are handled with care and efficiency.
            </Description>
          </TextArea>
          <TrackPackageForm />
        </TextAndForm>
        <ImgContainer>
          <Img src="/static/svg/auth-backdrop.svg" />
        </ImgContainer>
      </Container>
    </Page>
  );
};

export default Home;

const Container = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow: hidden;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const TextAndForm = styled.div`
  margin: auto;
  margin-left: 6.69rem;
  margin-right: 4.75rem;
  display: flex;
  flex-direction: column;
  gap: 3.5rem;

  @media (max-width: 480px) {
    margin: 0;
    gap: 2.25rem;
  }
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const Header = styled.h1`
  font-size: 3.375rem;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.text6};
  line-height: 120%;

  & > span {
    color: ${({ theme }) => theme.palette.primaryFocused};
  }

  @media (max-width: 480px) {
    font-size: 2rem;
    margin-top: 3.12rem;
  }
`;

const Description = styled.p`
  color: ${({ theme }) => theme.palette.text5};
  font-size: 1.25rem;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const ImgContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  @media (max-width: 480px) {
    display: none;
  }
`;

const Img = styled.img`
  object-fit: cover;
  object-position: left top;
`;
